export default "__VITE_ASSET__C2S346cO__"